import Operation from "../index.js";

export default {
    //培训机构根据id查询社区设置
    findCommunitySettings(id, fn) {
        Operation.Http.post(`/institution/findCommunitySettings?id=${id}`, null, fn)
    },
    //轮播图列表
    institutionNoticeList(params, fn) {
        Operation.Http.post(`/institution/institutionNoticeList`, params, fn)
    },
    //培训机构根据id查询社区设置
    findCommunitySettingsByRN(id, fn) {
        Operation.Http.post(`/institution/findCommunitySettingsByRN?realmNameHead=${id}`, null, fn)
    },
    //机构数据采集
    statisticsByInstitutionId(params, fn) {
        let { institutionId, type } = params;
        Operation.Http.post(`/institution/statisticsByInstitutionId?institutionId=${institutionId}&filedName=${type}&num=1`, null, fn)
    }

}


// WEBPACK FOOTER //
// ./src/request/api/institution.js